var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNikeLogoNewIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon nike-logo-new-icon",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.473h4.301l1.454-6.668c.728-3.291 2.53-9.35 4.68-9.35.442 0 .79.245.79 1.058 0 .324-.063.732-.19 1.26l-1.738 7.724c-.318 1.422-.57 2.805-.57 3.618 0 1.869.76 2.885 1.866 2.885 2.561 0 4.047-3.171 5.407-5.488l-.664-.61c-.317.61-1.36 2.642-2.024 2.642-.221 0-.316-.162-.316-.609 0-.284.063-.731.158-1.22l1.992-8.699c.126-.487.348-1.788.348-2.439C15.494 1.585 14.482 0 12.87 0c-2.34 0-4.964 2.845-6.735 7.602l-.063-.082L7.779.447 7.463 0C5.882.854 3.036 1.138 1.392 1.138l-.158 1.098c1.328 0 1.833.081 1.833.976 0 .447-.094 1.463-.252 2.195L0 19.473",
    fillRule: "evenodd"
  })));
}

export default SvgNikeLogoNewIconSv;